import { SupplierDataConnectionProvider } from '@40seas/entities/bank-connectivity';
import { Country, EnumSchema, Environment, Executor, FromSchema } from '@40seas/entities/common';
import { PeriodicErpSync, PeriodicErpSyncSchema } from '@40seas/entities/erp-sync';
import { Organization } from '@40seas/entities/organizations';
import { TenantlessBaseEntity, WithTenantlessBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore - Fix TS FS-3199
export const TenantSchema = WithTenantlessBaseEntitySchema(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    z.object({
        tenantId: z.string(),
        authenticationId: z.string().optional(),
        displayName: z.string().optional(),
        organizationId: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .or(z.any())
            .optional(), // TBD - add schema for business, seller and buyer -,
        stripeAccountId: z.string().optional(),
        businessId: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .optional(),
        webhookApplicationId: z.string().optional(),
        environment: EnumSchema(Environment),
        preapprove: z
            .object({
                isActive: z.boolean(),
            })
            .optional(),
        erpSettings: z
            .object({
                isActive: z.boolean(),
                provider: EnumSchema(SupplierDataConnectionProvider).optional(),
            })
            .optional(),
        externalBuyersWirePaymentMethod: z
            .object({
                isActive: z.boolean(),
            })
            .optional(),
        supportedCountries: z.array(EnumSchema(Country)).optional(),
        showCreditlinePromotion: z.boolean().optional(),
        theme: z.any().optional(),
        disablePaymentsCalendar: z.boolean().optional(),
        periodicErpSync: PeriodicErpSyncSchema.optional(),
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
).strict();

export class Tenant extends FromSchema(TenantSchema) implements TenantlessBaseEntity {
    id: string;
    tenantId: string;
    displayName?: string;
    authenticationId?: string;
    organizationId?: string | Organization;
    stripeAccountId?: string;
    businessId?: string;
    webhookApplicationId?: string;
    environment?: Environment;
    preapprove?: CreditLinePreapprove;
    externalBuyersWirePaymentMethod?: ExternalBuyersWirePaymentMethod;
    createdBy?: Executor;
    createdAt: Date;
    updatedAt: Date;
    supportedCountries?: Country[];
    showCreditlinePromotion?: boolean;
    theme?: object;
    disablePaymentsCalendar?: boolean;
    erpSettings?: ErpSettings;
    periodicErpSync?: PeriodicErpSync;
}

export class CreditLinePreapprove {
    isActive: boolean;
}

export class ExternalBuyersWirePaymentMethod {
    isActive: boolean;
}

export class ErpSettings {
    isActive: boolean;
    provider: SupplierDataConnectionProvider;
}
